import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { Observable } from 'rxjs';
import { Messaging } from '@angular/fire/messaging';
import { getToken, onMessage } from 'firebase/messaging';
import { ApiService } from './core/services/api.service';
import { NotificationService } from './core/services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class FcmService {
 
  dtoptions : any = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit', 
    hour12: false // Use 24-hour time format
  };

  notifyUser : any = '';
  
  loginUserId : any = JSON.parse(localStorage.getItem('UserDetails')!)?.userid;

  constructor(private messaging: Messaging,public apiService : ApiService,private notificationService: NotificationService) {
    //this.checkInitialization();

  }

  

  requestPermissionAndToken() {
    Notification.requestPermission().then(async (permission) => {
      if (permission === 'granted') {
        const token = await getToken(this.messaging, {
          vapidKey: 'BDbQNOkPke_iV946hxpY0Ys1oNrti9q38uG7dYW-RnJlwuRtbChLwnsWcPzl84q7hJUpENtzqDDNxMY1v2BCdwY',
          serviceWorkerRegistration: await navigator.serviceWorker.ready
        });
       
        setTimeout(async () => {
          var userSession: any = localStorage.getItem('userInfo');
          var userObj = JSON.parse(userSession);

          var fcmTokenSession : any = localStorage.getItem('fcmToken');
          fcmTokenSession = JSON.parse(fcmTokenSession); 

          if(localStorage.getItem('fcmToken') && userObj?.group == fcmTokenSession?.group_code){     // If Local Storage FCM token exists
            
           // console.log('Register token locastorage : ', fcmTokenSession);
          }else{                                    // If Local Storage FCM token not exists and Requesting for Token 
              const now = new Date();
            
              console.log('User Info FCM service:', userObj);

              var obj: any = {
                "user_aou_id": userObj?.user_Info.uid,
                "group_code": userObj?.group,
                "fcm_token": token,
                "device_type": "W",
                "action": "I",
                "clientts": this.formatDate(now)
              };

              this.apiService.postmethod('fcm/addfcmtoken', obj).subscribe((res: any) => {
                //console.log('Fcm Token Add:', res);
                localStorage.setItem('fcmToken', JSON.stringify(obj)); // ✅ fix
                //console.log('Get Local Fcm token : ', localStorage.getItem('fcmToken'));
              });
          }
        }, 1000);

        

       
      } else {
        console.warn('Notification permission denied');
      }
    });
  }

  listenToMessages() {
    onMessage(this.messaging, (payload) => {
     // console.log('Foreground message received:', payload);

      // Optionally show in-app notification
      if (Notification.permission === 'granted') {
        new Notification(payload.notification?.title || 'Message', {
          body: payload.notification?.body,
          icon: payload.notification?.icon || 'images/notifylogo.png'
        });
      }


      // Refresh unread count
      this.notificationService.checkStatus();
    });
  }

formatDate(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');

  const month = pad(date.getMonth() + 1); // Months are 0-based
  const day = pad(date.getDate());
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}

}

